
import { defineComponent } from 'vue';
import { mapState, mapGetters } from 'vuex';
import { useProcessAvatar } from '@/composables';
// TODO: 点击弹出侧栏

export default defineComponent({
  setup() {
    const { processAvatar } = useProcessAvatar();
    return {
      processAvatar,
    };
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['userLoggedIn']),
  },
});
